import React, { useEffect, useState } from "react";
import AdminPageLayout from "../components/AdminPageLayout";
import { useToast } from "../../common/toast/ToastContext";
import {
  fetchAdminContentCategories,
  createContentCategory,
  updateContentCategory,
  deleteContentCategory,
} from "./adminContentService";

const inp = { width: "100%", padding: "8px 12px", borderRadius: 6, border: "1px solid #ccc", boxSizing: "border-box" };

const AdminContentCategoriesPage = () => {
  const { showToast } = useToast();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");
  const [newName, setNewName] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    const res = await fetchAdminContentCategories();
    if (res.status === 200) setCategories(Array.isArray(res.data) ? res.data : res.data.content ?? []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!newName.trim()) { showToast("Name is required", "error"); return; }
    setSaving(true);
    const res = await createContentCategory({ name: newName.trim() });
    setSaving(false);
    if (res.status === 200 || res.status === 201) {
      showToast("Category created", "success");
      setNewName("");
      load();
    } else {
      showToast(res.message || "Create failed", "error");
    }
  };

  const handleUpdate = async (id) => {
    if (!editName.trim()) { showToast("Name is required", "error"); return; }
    setSaving(true);
    const res = await updateContentCategory(id, { name: editName.trim() });
    setSaving(false);
    if (res.status === 200) {
      showToast("Updated", "success");
      setEditingId(null);
      load();
    } else {
      showToast(res.message || "Update failed", "error");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this category? Content blocks using it will lose their category.")) return;
    const res = await deleteContentCategory(id);
    if (res.status === 200 || res.status === 204) { showToast("Deleted", "success"); load(); }
    else showToast(res.message || "Delete failed", "error");
  };

  return (
    <AdminPageLayout
      title="Content Categories"
      subtitle="Manage categories used to organise content blocks."
    >
      {/* Add new */}
      <div style={{ display: "flex", gap: 10, marginBottom: 28, maxWidth: 480 }}>
        <input
          style={{ ...inp, flex: 1 }}
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="New category name…"
          onKeyDown={(e) => e.key === "Enter" && handleCreate()}
        />
        <button
          onClick={handleCreate}
          disabled={saving}
          style={{ padding: "8px 20px", background: "#019095", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}
        >
          + Add
        </button>
      </div>

      {loading ? (
        <p className="adm-loading">Loading…</p>
      ) : categories.length === 0 ? (
        <p style={{ color: "#aaa" }}>No categories yet. Add one above.</p>
      ) : (
        <table className="announcement-table">
          <thead>
            <tr><th>#</th><th>Name</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {categories.map((cat) => (
              <tr key={cat.id}>
                <td style={{ color: "#aaa", width: 40 }}>{cat.id}</td>
                <td>
                  {editingId === cat.id ? (
                    <input
                      autoFocus
                      style={{ ...inp, maxWidth: 320 }}
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                      onKeyDown={(e) => { if (e.key === "Enter") handleUpdate(cat.id); if (e.key === "Escape") setEditingId(null); }}
                    />
                  ) : (
                    <span style={{ fontWeight: 500 }}>{cat.name}</span>
                  )}
                </td>
                <td>
                  {editingId === cat.id ? (
                    <>
                      <button onClick={() => handleUpdate(cat.id)} disabled={saving} style={{ marginRight: 6, padding: "4px 14px", background: "#019095", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer" }}>Save</button>
                      <button onClick={() => setEditingId(null)} style={{ padding: "4px 12px", border: "1px solid #ccc", background: "#fff", borderRadius: 5, cursor: "pointer" }}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => { setEditingId(cat.id); setEditName(cat.name); }} style={{ marginRight: 6 }}>Edit</button>
                      <button className="delete-btn" onClick={() => handleDelete(cat.id)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </AdminPageLayout>
  );
};

export default AdminContentCategoriesPage;
